const state = {
  csvError: "",
  disabledForward: false,
  csvHeaders: [],
  csvData: [],
  droppedFile: null,
  studyName: ""
};

const getters = {
  getCsvError(state) {
    return state.csvError;
  },
  getMovingForward(state) {
    return state.disabledForward;
  },
  getCsvHeaders(state) {
    return state.csvHeaders;
  },
  getCsvData(state) {
    return state.csvData;
  },
  getDroppedFile(state) {
    return state.droppedFile;
  },
  getStudyName(state) {
    return state.studyName;
  }
};

const mutations = {
  storeCsvError(state, payload) {
    state.csvError = payload;
  },
  storeForwardState(state, payload) {
    state.disabledForward = payload;
  },
  storeCsvHeaders(state, payload) {
    state.csvHeaders = payload;
  },
  storeCsvData(state, payload) {
    state.csvData = payload;
  },
  storeDropedFile(state, payload) {
    state.droppedFile = payload;
  },
  storeStudyName(state, payload) {
    state.studyName = payload;
  }
};

const actions = {
  changeStep({ commit }, step) {
    commit("storeStep", step);
  },
  setCsvError({ commit }, error) {
    commit("storeCsvError", error);
  },
  changeForwardState({ commit }, step) {
    commit("storeForwardState", step);
  },
  changeCsvHeaders({ commit }, headers) {
    commit("storeCsvHeaders", headers);
  },
  changeCsvData({ commit }, data) {
    commit("storeCsvData", data);
  },
  changeDroppedFile({ commit }, file) {
    commit("storeDropedFile", file);
  },
  changeStudyName({ commit }, name) {
    commit("storeStudyName", name);
  }
};

export default {
  state,
  mutations,
  actions,
  getters
};
